import { useEffect } from "react";
import { ThemeProvider, styled } from "styled-components";

import Header from "./components/organisms/Header";
import About from "./components/organisms/About";
import WhatIDo from "./components/organisms/WhatIDo";

import { theme } from "./styles/theme";
import { GlobalStyle } from "./styles/GlobalStyle";
import Skills from "./components/organisms/Skills";
import Experience from "./components/organisms/Experience";
import Works from "./components/organisms/Works";
import Contact from "./components/organisms/Contact";

function App() {
  useEffect(() => {
    const cursor: any = document.querySelector("#cursor");
    document.addEventListener("mousemove", (e) => {
      const scrollX = window.pageXOffset;
      const scrollY = window.pageYOffset;
      const cursorX = e.pageX - scrollX;
      const cursorY = e.pageY - scrollY;

      cursor.style.left = cursorX + "px";
      cursor.style.top = cursorY + "px";
    });
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <GlobalStyle />
      <Header />

      <main>
        <About />
        <WhatIDo />
        <Skills />
        <Experience />
        <Works />
        <Contact />
      </main>

      <StyledCursor id="cursor" />
    </ThemeProvider>
  );
}

const StyledCursor = styled.div`
  position: fixed;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.colors.primaryText};
  transform: translate(-50%, -50%);
  pointer-events: none;
  mix-blend-mode: difference;
  z-index: 100;

  @media (max-width: 991px) {
    display: none;
  }
`;

export default App;
